import React from 'react';
import './styles.css';

interface TechnologieProps {
    name: string;
}

const TechnologieCard: React.FC<TechnologieProps> = ({name}) => {
    return (
        <div className="technologie-card">
            <p>{name}</p>
        </div>
    )
} 

export default TechnologieCard;